'use strict';

var OnlineLogitCalibrationReviewHeaderDirective = function OnlineLogitCalibrationReviewHeaderDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/online-logit-calibration-review-header.html'),
    scope: {
      headerData: '=',
      gridStatus: '=',
      isSaveEnabled: '=',
      triggerSave: '&',
      isPublishEnabled: '&',
      triggerPublish: '&'
    }
  };
};
OnlineLogitCalibrationReviewHeaderDirective.$inject = [];
module.exports = OnlineLogitCalibrationReviewHeaderDirective;